import { AbstractControl, ValidationErrors } from '@angular/forms';
import { NotificationPlanRule } from '../../../index';

export const ValidatorAdministratorMessage = 'Recipients not added';

export function pushRecipientValidator(control: AbstractControl): ValidationErrors | null {
  if (!control?.value) return null;

  const { users, type } = control.value;

  const specifiedUsersChecked = Boolean(type & NotificationPlanRule.SpecifiedEmails);

  if (specifiedUsersChecked && users.length === 0) {
    return { users: { message: ValidatorAdministratorMessage } };
  }

  return null;
}
